import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import AuthLayout from '../../../components/auth/AuthLayout';
import { useSignup } from '../../../contexts/SignupContext';

const SignupAadhaarUpload = () => {
  const navigate = useNavigate();
  const { updateSignupState } = useSignup();
  const [frontFile, setFrontFile] = useState(null);
  const [backFile, setBackFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!frontFile || !backFile) {
      toast.error('Please upload both front and back images of Aadhaar');
      return;
    }

    setLoading(true);

    updateSignupState({
      aadhaarUploadUrls: {
        front: frontFile.name,
        back: backFile.name,
      },
      aadhaarDetails: {
        name: 'Demo Aadhaar Upload User',
        docType: 'Aadhaar Upload',
      },
    });

    toast.success('Aadhaar uploaded successfully');
    navigate('/signup/business');
    setLoading(false);
  };

  return (
    <AuthLayout
      title="Upload Aadhaar"
      subtitle="Upload clear front and back images of your Aadhaar card"
      onBack={() => navigate('/signup/aadhaar')}
    >
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">Front Image</label>
          <input
            type="file"
            accept="image/*"
            className="form-input"
            onChange={(event) => setFrontFile(event.target.files?.[0] || null)}
            required
          />
        </div>
        <div className="form-group">
          <label className="form-label">Back Image</label>
          <input
            type="file"
            accept="image/*"
            className="form-input"
            onChange={(event) => setBackFile(event.target.files?.[0] || null)}
            required
          />
        </div>
        <button type="submit" className="signin-btn" disabled={loading}>
          {loading ? 'Uploading...' : 'Upload & Continue'}
        </button>
      </form>
    </AuthLayout>
  );
};

export default SignupAadhaarUpload;


